import { useSearchParams } from "react-router-dom";

export const UserFilterType = {
    Role: 'role',
    Search: 'search',
    Page: 'page',
    PageSize: 'page_size',
    ClientId: 'client_id',
} as const;

export type UserFilterType = typeof UserFilterType[keyof typeof UserFilterType];


export default function useGetUsersFiltersQuery() {
    const [searchParams] = useSearchParams();

    const roleQuery = searchParams.get(UserFilterType.Role);
    const searchQuery = searchParams.get(UserFilterType.Search);
    const pageQuery = searchParams.get(UserFilterType.Page);
    const pageSizeQuery = searchParams.get(UserFilterType.PageSize);
    const clientIdQuery = searchParams.get(UserFilterType.ClientId);




    return {
        roleQuery,
        pageSizeQuery,
        pageQuery,
        searchQuery,
        clientIdQuery,
    };
}
